const AppConfig = {
  //baseURL: "https://localhost:5127/",
  //paymentURL: "https://localhost:5127/",
  baseURL: "https://coreapi.triotrip.com/",
  paymentURL: "https://link.triotrip.com/",
  dateFormat: "dd-MMM-yyyy",
  currencyFormat: "",
  refreshInterval:100
};

export default AppConfig;
